<template>
  <div v-if="isOpen">
    <div class="modal is-active">
      <div class="modal-background"></div>

      <div class="animation-content" :style="'max-width: ' + computedWidth + 'px'">
        <div :class="['modal-card', {'full-height': fullHeight}]">
          <header class="modal-card-head">
            <p class="modal-card-title">
              <span v-if="subtitle" class="modal-card-subtitle">{{ subtitle }}</span>
              <span :class="{'modal-card-title-with-subtitle': subtitle}">{{ title }}</span>
            </p>
            <button v-if="!hideCloseButton" type="button" class="delete" aria-label="close" @click="close"></button>
          </header>

          <section class="modal-card-body">
            <slot></slot>
          </section>

          <footer v-if="$slots.footer" class="modal-card-foot">
            <slot name="footer"></slot>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalBase",
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: String,
    navigate: {
      type: String,
      required: false,
    },
    width: {
      type: Number,
      default: 420
    },
    isDoubleColumn: {
      type: Boolean,
      default: false
    },
    isTripleColumn: {
      type: Boolean,
      default: false
    },
    isWide: {
      type: Boolean,
      default: false
    },
    fullHeight: {
      type: Boolean,
      default: false
    },
    onClosePrompt: {
      type: Function,
      required: false,
    },
    onCloseClearQuery: {
      type: Boolean,
      default: false
    },
    shortCircuitClose: {
      type: Boolean,
      default: false
    },
    hideCloseButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      computedWidth: 420
    }
  },
  mounted() {
    if(this.isDoubleColumn) {
      this.computedWidth = 660;
    } else if(this.isTripleColumn) {
      this.computedWidth = 1020;
    } else if(this.isWide) {
      this.computedWidth = 768;
    } else {
      this.computedWidth = this.width;
    }
  },
  methods: {
    open() {
      this.isOpen = true;
      this.$emit('open');
    },
    async close() {
      if (this.shortCircuitClose) {
        this.$emit('close');
        return;
      }

      if (this.onClosePrompt) {
        let result = await this.onClosePrompt();

        // If the on close prompt returns false, then the close will be aborted
        if (result === false) {
          return;
        }
      }

      this.isOpen = false;
      this.$emit('close');

      if (this.$route.name !== this.navigate && this.navigate !== undefined) {
        this.$router.push({ name: this.navigate });
        return
      }

      if (this.onCloseClearQuery && JSON.stringify(this.$route.query) !== '{}') {
        // this is to remove all query strings that is used in opening a modal
        this.$router.replace({...this.$router.currentRoute, query: ''});
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.modal-card-title {
  flex-shrink: 1;
}

.modal-card-subtitle {
  display: block;
  margin-bottom: 3px;
  font-size: 0.875rem;
}

.modal-card-title-with-subtitle {
  display: block;
  font-size: 1.5rem;
  font-weight: bold;
}

.modal-card-body {
  padding: 0;
}

.modal-card-foot {
  flex-wrap: wrap;
}
</style>
